import { render, staticRenderFns } from "./NotificationSendList.vue?vue&type=template&id=18a72e79&"
import script from "./NotificationSendList.vue?vue&type=script&lang=ts&"
export * from "./NotificationSendList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports